module.exports = __webpack_public_path__ + "images/550fbd8001c1ec57a8fe37d7600358febox.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/box.png
// module id = GYb9
// module chunks = 0